"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');


var _ZMH55N2Icjs = require('../__chunks/ZMH55N2I.cjs');
require('../__chunks/OTCKJ4OK.cjs');


var _STJK5WUWcjs = require('../__chunks/STJK5WUW.cjs');


var _VKRKCS23cjs = require('../__chunks/VKRKCS23.cjs');
require('../__chunks/AYPF6BUR.cjs');
require('../__chunks/XIM2KQSL.cjs');
require('../__chunks/7JL3CCPE.cjs');
require('../__chunks/2XVCJUVB.cjs');


var _VYZTFWCGcjs = require('../__chunks/VYZTFWCG.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-button.tsx
var _dom = require('@ariakit/core/utils/dom');




var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
function getInitialFocus(event, dir) {
  const keyMap = {
    ArrowDown: dir === "bottom" || dir === "top" ? "first" : false,
    ArrowUp: dir === "bottom" || dir === "top" ? "last" : false,
    ArrowRight: dir === "right" ? "first" : false,
    ArrowLeft: dir === "left" ? "first" : false
  };
  return keyMap[event.key];
}
function hasActiveItem(items, excludeElement) {
  return !!(items == null ? void 0 : items.some((item) => {
    if (!item.element) return false;
    if (item.element === excludeElement) return false;
    return item.element.getAttribute("aria-expanded") === "true";
  }));
}
var useMenuButton = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuButton2({
    store,
    focusable,
    accessibleWhenDisabled,
    showOnHover,
    ...props
  }) {
    const context = _XXF5DFSGcjs.useMenuProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "MenuButton must receive a `store` prop or be wrapped in a MenuProvider component."
    );
    const ref = _react.useRef.call(void 0, null);
    const parentMenu = store.parent;
    const parentMenubar = store.menubar;
    const hasParentMenu = !!parentMenu;
    const parentIsMenubar = !!parentMenubar && !hasParentMenu;
    const disabled = _misc.disabledFromProps.call(void 0, props);
    const isDisabled = (element) => disabled || _misc.disabledFromElement.call(void 0, element);
    const showMenu = () => {
      const trigger = ref.current;
      if (!trigger) return;
      store == null ? void 0 : store.setDisclosureElement(trigger);
      store == null ? void 0 : store.setAnchorElement(trigger);
      store == null ? void 0 : store.show();
    };
    const onFocusProp = props.onFocus;
    const onFocus = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (isDisabled(event.currentTarget)) return;
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.setAutoFocusOnShow(false);
      store == null ? void 0 : store.setActiveId(null);
      if (!parentMenubar) return;
      if (!parentIsMenubar) return;
      const { items } = parentMenubar.getState();
      if (hasActiveItem(items, event.currentTarget)) {
        showMenu();
      }
    });
    const dir = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.placement.split("-")[0]
    );
    const onKeyDownProp = props.onKeyDown;
    const onKeyDown = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (isDisabled(event.currentTarget)) return;
      if (event.defaultPrevented) return;
      const initialFocus = getInitialFocus(event, dir);
      if (initialFocus) {
        event.preventDefault();
        showMenu();
        store == null ? void 0 : store.setAutoFocusOnShow(true);
        store == null ? void 0 : store.setInitialFocus(initialFocus);
      }
    });
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (!store) return;
      const isKeyboardClick = !event.detail;
      const { open } = store.getState();
      if (!open || isKeyboardClick) {
        if (!hasParentMenu || isKeyboardClick) {
          store.setAutoFocusOnShow(true);
        }
        store.setInitialFocus(isKeyboardClick ? "first" : "container");
      }
      if (hasParentMenu) {
        showMenu();
      }
    });
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XXF5DFSGcjs.MenuContextProvider, { value: store, children: element }),
      [store]
    );
    if (hasParentMenu) {
      props = {
        ...props,
        render: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _VYZTFWCGcjs.Role.div, { render: props.render })
      };
    }
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const parentContentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      (parentMenu == null ? void 0 : parentMenu.combobox) || parentMenu,
      "contentElement"
    );
    const role = hasParentMenu || parentIsMenubar ? _dom.getPopupItemRole.call(void 0, parentContentElement, "menuitem") : void 0;
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
    props = {
      role,
      "aria-haspopup": _dom.getPopupRole.call(void 0, contentElement, "menu"),
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref),
      onFocus,
      onKeyDown,
      onClick
    };
    props = _ZMH55N2Icjs.useHovercardAnchor.call(void 0, {
      store,
      focusable,
      accessibleWhenDisabled,
      ...props,
      showOnHover: (event) => {
        const getShowOnHover = () => {
          if (typeof showOnHover === "function") return showOnHover(event);
          if (showOnHover != null) return showOnHover;
          if (hasParentMenu) return true;
          if (!parentMenubar) return false;
          const { items } = parentMenubar.getState();
          return parentIsMenubar && hasActiveItem(items);
        };
        const canShowOnHover = getShowOnHover();
        if (!canShowOnHover) return false;
        const parent = parentIsMenubar ? parentMenubar : parentMenu;
        if (!parent) return true;
        parent.setActiveId(event.currentTarget.id);
        return true;
      }
    });
    props = _VKRKCS23cjs.usePopoverDisclosure.call(void 0, {
      store,
      toggleOnClick: !hasParentMenu,
      focusable,
      accessibleWhenDisabled,
      ...props
    });
    props = _STJK5WUWcjs.useCompositeTypeahead.call(void 0, {
      store,
      typeahead: parentIsMenubar,
      ...props
    });
    return props;
  }
);
var MenuButton = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuButton2(props) {
  const htmlProps = useMenuButton(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuButton = MenuButton; exports.useMenuButton = useMenuButton;
